import { AIProviderSettings } from "@/components/settings/ai-provider/AIProviderSettings";
import { createFileRoute } from "@tanstack/react-router";
import { useWorkspace } from "../route";

function AIProviderPage() {
  const { workspace } = useWorkspace();
  return (
    <AIProviderSettings workspaceId={workspace._id} role={workspace.role} />
  );
}

export const Route = createFileRoute("/$workspaceSlug/settings/ai-provider")({
  component: AIProviderPage,
});
